import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import SearchIcon from "@mui/icons-material/Search";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Slot() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [isLoading, setLoading] = useState(false);
    const [game, setGame] = useState([]);
    const [searchQuery, setSearchQuery] = useState(""); 
    const [selectedProvider, setSelectedProvider] = useState(null); 
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState(null);

    const navigate = useNavigate();

    // --- MẢNG DANH SÁCH SẢNH GAME ---
    const providerList = [
        { id: "pp", name: "PPLAY SLOTS", productType: "39", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/pplay.png" },
        { id: "cq9", name: "CQ9 SLOTS", productType: "16", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/cq9.png" },
        { id: "jili", name: "JILI SLOTS", productType: "140", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/jili.png" },
        { id: "jdb", name: "JDB SLOTS", productType: "55", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/spadegaming.png" },
        { id: "ag", name: "AG SLOTS", productType: "4", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/platipus.png" },
        { id: "bbin", name: "BBIN SLOTS", productType: "79", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/rtg.png" },
        { id: "mg", name: "MG SLOTS", productType: "43", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/btg.png" },
        { id: "fc", name: "FC SLOTS", productType: "141", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/netent.png" },
        { id: "pg", name: "PG SLOTS", productType: "98", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/pg.png" },
        { id: "168Game", name: "168Game SLOTS", productType: "275", gameType: "RNG", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/slot/rich88.png" },
    ];

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // Khi người dùng click chọn 1 Sảnh game
    const handleProviderClick = (provider) => {
        setSelectedProvider(provider);
        setGame([]); 
        setSearchQuery(""); 
        setLoading(true);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { 
                product_type: provider.productType, 
                game_type: provider.gameType 
            })
            .then((res) => {
                if (res.data.data.length === 0) {
                    setLoading(false);
                    swal("Thông báo", "Sảnh game bảo trì", "error").then(() => setGame([]));
                } else {
                    setGame(res.data.data[0]); 
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                swal("Thông báo", "Sảnh game bảo trì", "error").then(() => setGame([]));
            });
    };

    // ==========================================
    // LOGIC VÀO GAME & TỰ ĐỘNG CHUYỂN TIỀN VÀO
    // ==========================================
    const launchGame = async (params) => {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading) return;
        setLoading(true);

        try {
            // 1. Lấy link game
            const form = {
                ...params,
                platform: isMobileDevice() ? "html5" : "html5-desktop"
            };
            const resGame = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (resGame.data.data.status !== 0) {
                setLoading(false);
                swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                return;
            }

            const gameUrl = resGame.data.data.game_url;
            setProduct(params.product_type);

            // 2. Tự động chuyển toàn bộ tiền từ ví chính vào sảnh
            if (profile && profile.money >= 1000) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: params.product_type,
                        type: 1, // 1 là chuyển vào
                        money: Math.floor(profile.money)
                    });
                } catch (transferErr) {
                    console.log("Lỗi chuyển tiền vào sảnh, vẫn tiếp tục mở game:", transferErr);
                }
            }

            // 3. Mở game trực tiếp trên Web
            setPlayGame(gameUrl);
            setLoading(false);

        } catch (err) {
            setLoading(false);
            if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                return;
            }
            swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
        }
    };

    // ==========================================
    // LOGIC THOÁT GAME & TỰ ĐỘNG CHUYỂN TIỀN RA
    // ==========================================
    const exitGame = async () => {
        if (isLoading) return;
        
        // Đóng Iframe ngay lập tức để người chơi không phải đợi
        setPlayGame(null);
        
        if (!product) return;
        setLoading(true);

        try {
            // 1. Kiểm tra số dư hiện tại trong sảnh
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product });
            const currentBal = resBal.data.data.balance;
            
            // 2. Rút toàn bộ tiền từ sảnh ra ví chính
            if (currentBal >= 1) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: product,
                    type: 2, // 2 là chuyển ra
                    money: Math.floor(currentBal)
                });
                console.log("Rút tiền sảnh thành công!"); // Chỉ in log
            }
            
            // 3. Cập nhật lại số dư Profile hiển thị
            const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            setProfile(resProfile.data.data);
            localStorage.setItem("profile", JSON.stringify(resProfile.data.data));
            
        } catch (err) {
            console.log("Rút tiền sảnh thất bại!", err);
        } finally {
            setLoading(false);
            setProduct(null);
        }
    };

    function handleImageError(e, productCode, tcgGameCode) {
        e.target.onerror = null; 
        e.target.src = `https://images.21947392.com/TCG_GAME_ICONS/${productCode}/${tcgGameCode}.png`;
    }

    // Lọc danh sách game theo ô tìm kiếm
    const filteredGames = game?.length > 0 
        ? game.filter(item => item.gameName.toLowerCase().includes(searchQuery.toLowerCase())) 
        : [];

    return (
        <>
            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    background-color: #0d121c !important; 
                    margin: 0; padding: 0;
                }
                .slot-page-wrapper {
                    background: #0d121c; /* Màu nền tối giống thiết kế */
                    min-height: calc(100vh - 60px);
                    padding: 40px 0;
                }
                .slot-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 15px;
                }
                
                /* GIAO DIỆN SẢNH (PROVIDER GRID) */
                .provider-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 30px;
                }
                @media (max-width: 900px) {
                    .provider-grid { grid-template-columns: repeat(2, 1fr); }
                }
                @media (max-width: 600px) {
                    .provider-grid { grid-template-columns: 1fr; }
                }
                .provider-card {
                    position: relative;
                    border-radius: 12px;
                    overflow: hidden;
                    cursor: pointer;
                    background: #1e2433;
                    transition: transform 0.3s;
                }
                .provider-card:hover {
                    transform: translateY(-5px);
                }
                .provider-card img {
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    display: block;
                }
                .provider-name-bar {
                    background: #0b0f17;
                    color: #ffd700;
                    text-align: center;
                    padding: 12px;
                    font-size: 18px;
                    font-weight: bold;
                    text-transform: uppercase;
                }
                .provider-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 200px;
                    background: rgba(0, 0, 0, 0.7);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: #ffd700;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }
                .provider-card:hover .provider-overlay {
                    opacity: 1;
                }
                .provider-overlay svg {
                    font-size: 50px;
                    margin-bottom: 10px;
                }
                .provider-overlay span {
                    font-size: 18px;
                    font-weight: bold;
                }

                /* GIAO DIỆN DANH SÁCH GAME CON */
                .game-list-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 2px solid #d32f2f;
                    padding-bottom: 15px;
                    margin-bottom: 30px;
                }
                .gl-title-wrap {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }
                .gl-btn-back {
                    background: transparent;
                    border: none;
                    color: #fff;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 16px;
                }
                .gl-btn-back:hover { color: #d32f2f; }
                .gl-title {
                    color: #fff;
                    font-size: 24px;
                    font-weight: bold;
                    text-transform: uppercase;
                    margin: 0;
                }
                .gl-search-box {
                    position: relative;
                    width: 300px;
                }
                .gl-search-box input {
                    width: 100%;
                    padding: 10px 15px 10px 40px;
                    border-radius: 20px;
                    border: none;
                    background: #2b3245;
                    color: #fff;
                    outline: none;
                }
                .gl-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #8fa0c0;
                }

                .new-grid-6 {
                    display: grid;
                    grid-template-columns: repeat(6, 1fr);
                    gap: 15px;
                }
                @media (max-width: 1200px) { .new-grid-6 { grid-template-columns: repeat(4, 1fr); } }
                @media (max-width: 800px) { .new-grid-6 { grid-template-columns: repeat(3, 1fr); } }
                @media (max-width: 500px) { .new-grid-6 { grid-template-columns: repeat(2, 1fr); } }

                .new-gameslot-item {
                    background: #2b3245;
                    border-radius: 10px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: transform 0.2s;
                }
                .new-gameslot-item:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.5);
                }
                .new-gameslot-item img {
                    width: 100%;
                    height: auto;
                    aspect-ratio: 1/1;
                    object-fit: cover;
                    display: block;
                }
                .new-gameslot-name {
                    background: #1e2433;
                    color: #fff;
                    text-align: center;
                    padding: 10px 5px;
                    font-size: 13px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                /* --- IFRAME GAME NHÚNG TRONG TRANG --- */
                .embedded-game-container {
                    width: 100%;
                    height: calc(100vh - 60px); /* Chiều cao trừ đi thanh Header gốc */
                    display: flex;
                    flex-direction: column;
                    background: #111;
                }
                .embedded-game-header {
                    height: 50px;
                    background: #1a1a1a;
                    border-bottom: 2px solid #b71c1c;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start; /* Nút thoát nằm bên trái */
                    padding: 0 15px;
                }
                .btn-exit-game {
                    display: flex;
                    align-items: center;
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    padding: 8px 15px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 14px;
                    text-transform: uppercase;
                    transition: background 0.2s;
                }
                .btn-exit-game:active {
                    background: #b71c1c;
                    transform: scale(0.98);
                }
                .btn-exit-game span { 
                    margin-left: 5px; 
                }
                .game-iframe {
                    width: 100%;
                    flex: 1; /* Chiếm toàn bộ không gian còn lại */
                    border: none;
                    background: #000;
                }
            `}</style>

            <Header profile={profile} />
            
            {isLoading && (
                <div className="loading" style={{ position: "fixed", zIndex: 9999999 }}>
                    <div className="loader"></div>
                </div>
            )}

            {/* ĐIỀU KIỆN HIỂN THỊ: CHƯA VÀO GAME THÌ HIỆN LOBBY SLOT, VÀO GAME RỒI THÌ HIỆN IFRAME BÊN DƯỚI HEADER */}
            {!playGame ? (
                <div className="slot-page-wrapper">
                    <div className="slot-container">
                        
                        {/* NẾU CHƯA CHỌN SẢNH -> HIỂN THỊ DANH SÁCH 8 SẢNH GAME */}
                        {!selectedProvider ? (
                            <div className="provider-grid">
                                {providerList.map((provider, index) => (
                                    <div 
                                        className="provider-card" 
                                        key={index} 
                                        onClick={() => handleProviderClick(provider)}
                                    >
                                        <img src={provider.img} alt={provider.name} />
                                        <div className="provider-overlay">
                                            <SportsEsportsIcon />
                                            <span>Bắt đầu chơi</span>
                                        </div>
                                        <div className="provider-name-bar">{provider.name}</div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            
                            /* NẾU ĐÃ CHỌN SẢNH -> HIỂN THỊ CHI TIẾT CÁC GAME CON VÀ Ô TÌM KIẾM */
                            <div className="game-list-view">
                                <div className="game-list-header">
                                    <div className="gl-title-wrap">
                                        <button className="gl-btn-back" onClick={() => setSelectedProvider(null)}>
                                            <ArrowBackIcon /> Trở lại
                                        </button>
                                        <h2 className="gl-title">{selectedProvider.name}</h2>
                                    </div>
                                    <div className="gl-search-box">
                                        <SearchIcon className="gl-search-icon" />
                                        <input 
                                            type="text" 
                                            placeholder="Vui lòng nhập tên game..." 
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="new-grid-6">
                                    {filteredGames.length > 0 ? (
                                        filteredGames.map((item, index) => (
                                            <div 
                                                className="new-gameslot-item" 
                                                key={index} 
                                                onClick={() => launchGame({ product_type: item.productType, game_code: item.tcgGameCode })}
                                            >
                                                <img
                                                    src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`}
                                                    onError={(e) => handleImageError(e, item.productCode, item.tcgGameCode)}
                                                    alt={item.gameName}
                                                />
                                                <div className="new-gameslot-name">{item.gameName}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ color: '#fff', fontSize: '16px', gridColumn: '1 / -1', textAlign: 'center', padding: '50px 0' }}>
                                            {game?.length === 0 ? "Đang tải danh sách game..." : "Không tìm thấy game phù hợp!"}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="embedded-game-container">
                    <div className="embedded-game-header">
                        <button className="btn-exit-game" onClick={exitGame}>
                            <KeyboardArrowLeftOutlinedIcon style={{ fontSize: "20px" }}/>
                            <span>Thoát Game</span>
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        className="game-iframe" 
                        title="Slot Game" 
                        allowFullScreen 
                    />
                </div>
            )}
        </>
    );
}

export default Slot;